<template>
    <PopoverRight ref="popoverMenu" width="550px" >
        <div class="popover-slider-bar">
            <h1 class="bar-title">代理商{{isShow ? '查看' : '编辑'}}</h1>
            <el-form class="form-container" :model="factorInfo" :rules="factorRules" ref="userInfoForm"
                     :disabled="isShow ? true : false"
            >
                <h1 class="bar-sub-title">基本信息</h1>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">代理商名称</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item ">
                        <el-form-item label="" prop="name">
                            <el-input placeholder="请输入代理商名称"  v-model="factorInfo.name">
                            </el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">联系人</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item ">
                        <el-form-item label="" prop="contacts">
                            <el-input placeholder="请输入联系人"  v-model="factorInfo.contacts">
                            </el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">联系号码</span>
                        <label class="warn">*</label>
                    </div>
                    <div class="form-input-item ">
                        <el-form-item label="" prop="contact_number">
                            <el-input placeholder="请输入联系号码"  v-model="factorInfo.contact_number">
                            </el-input>
                        </el-form-item>
                    </div>
                </div>
                <div class="form-item">
                    <div class="form-label">
                        <span class="label">备注</span>
                    </div>
                    <div class="form-input-item ">
                        <el-form-item label="" prop="remark">
                            <el-input placeholder="请输入备注"  v-model="factorInfo.remark">
                            </el-input>
                        </el-form-item>
                    </div>
                </div>
                <template v-if="factorInfo.id > 1 && factorInfo.status==1">
                    <h1 class="bar-sub-title">签约状管理及好房云推送管理</h1>
                    <div class="form-item">
                        <div class="form-label">
                            <span class="label">签约站点</span>
                            <label class="warn">*</label>
                        </div>
                        <div class="form-input-item">
                            <el-form-item prop="checkedSites">
                                <site-auto-complete :factor-id="1" v-model="factorInfo.site_selected" @change="changeSites"></site-auto-complete>
                            </el-form-item>
                        </div>
                    </div>
                    <div class="form-select-checked-container">
                        <p v-for="(tag, key) in checkedSites" :key="key" class="item">
                            {{tag.name}}
                            <i class="el-icon-close" @click.stop.prevent="removeChecked(key)"></i>
                        </p>
                    </div>
                    <div class="form-select-site">
                        <el-card class="box-card" v-for="(item, key) in checkedSites" :key="key">
                            <div>
                                <span style="font-size:18px;margin-left:30px;font-weight: bold;">{{item.name}}</span>
                                <i class="el-icon-close" @click.stop.prevent="removeChecked(key)"></i>
                            </div>
                            <div class="form-item">
                                <div class="form-label" >
                                    <span class="label" style="text-align:center;color:#999">签约时间</span>
                                    <label class="warn">*</label>
                                </div>
                                <div class="form-input-item">
                                    <el-form-item label="">
                                        <el-date-picker
                                                v-model="checkedSites[key].signDate"
                                                type="daterange"
                                                range-separator="至"
                                                start-placeholder="开始日期"
                                                end-placeholder="结束日期"
                                        >
                                        </el-date-picker>
                                    </el-form-item>
                                </div>
                            </div>
                        </el-card>
                    </div>
                </template>
            </el-form>
            <div class="form-button">
                <el-button type="primary" @click="submitForm('userInfoForm')" v-if="factorInfo.status < 2">确 认</el-button>
                <el-button type="info" plain @click.stop.prevent="hide">取 消</el-button>
            </div>
        </div>
    </PopoverRight>
</template>

<script>
    import PopoverRight from '@/components/popoverRight/index'
    import {validateNumber} from  '@/utils/validate'
    import { modifyFactor, modifyFactorSites,verifyKeyStatus} from '@/service/user'
    import {validateChat, validateMobile} from '@/utils/validate'
    import SiteAutoComplete from "../../../../components/auto-complete/site-auto-complete";
    import {getUserInfo} from '@/utils/auth'

    export default {
        name: "edit",
        components: {
            SiteAutoComplete,
            PopoverRight
        },

        data () {
            let validDate = (rule,value,callback) => {
                if (!value || !value[0] || !value[1]) {
                    callback(new Error("请选择时间"))
                } else if (value[0] >= value[1]) {
                    callback(new Error("结束时间必须大于开始时间"))
                } else {
                    callback()
                }
            }
            let validateName = (rule,value,callback) => {
                if (!/^[a-zA-Z0-9\u4e00-\u9fa5\-_]*$/.test(value)) {
                    callback(new Error(rule.message))
                } else {
                    callback()
                }
            }
            let validateId = (rule,value,callback) => {
                if (!/^[a-zA-Z0-9\-_]*$/.test(value)) {
                    callback(new Error(rule.message))
                } else {
                    callback()
                }
            }
            let validateSite = (rule,value,callback) => {
                if (this.checkedSites.length <= 0) {
                    callback(new Error(rule.message))
                } else {
                    callback()
                }
            }
            return {
                isShow : 0,
                checkedSitesCopy : [],
                factorInfo: {
                    id : 0,
                    name: '',
                    contacts: '',
                    contact_number: '',
                    signDate : [],
                    sites : [],
                    status : 0,
                    remark : '',
                    sign_start_time : 0,
                    sign_end_time : 0,
                    site_selected : '',
                },
                checkedSites: [],
                originalSites:[],
                timeStatus:true,

                data: [
                ],
                factorRules: {
                    checkedSites : [
                        { validator: validateSite, message: '请选择站点', trigger: 'change' },
                    ],
                    signDate: [
                        { validator:validDate, trigger: 'change' }
                    ],
                    name: [
                        { required: true, message: '请输入代理商名称', trigger: 'blur' },
                        { min: 6, max: 20, message: '代理商名称长度为6-20个字符之间', trigger: 'blur' },
                    ],
                    contacts: [
                        { required: true, message: '请输入联系人', trigger: 'blur' },
                        { min: 2, max: 20, message: '联系人长度为2-20个字符之间', trigger: 'blur' },
                        {validator:validateName, trigger: 'blur', message:'代理商名称只能包含-_大小写字母、数字、中文'}
                    ],
                    contact_number: [
                        { required: true, message: '请填写联系人号码', trigger: 'blur' },
                        {validator:validateMobile, trigger: 'blur', result: '联系号码'}
                    ],
                    remark: [
                        { min:6,max:255, message: '请填写长度在 6 到 255 个字符备注', trigger: 'blur' }
                    ],
                },
                user:null
            }
        },
        methods : {
            changeSites (id) {
                let site = this.data.find(data => data.id === id)
                if (site && this.checkedSites.findIndex(data => data.id === id) < 0) {
                    this.$set(site,'signDate','');
                    this.checkedSites.push(site)
                }
            },
            removeChecked (index) {
                this.checkedSites.splice(index, 1)
                this.factorInfo.site_selected = this.checkedSites.length > 0 ? this.checkedSites[0].id : ''
            },
            open () {
                
                if (this.checkedSites.length > 0) {
                    this.originalSites=JSON.parse(JSON.stringify(this.checkedSites))
                    this.originalSites.forEach(el => {
                        el.signDate=[new Date(el.sign_start_date),new Date(el.sign_end_date)]
                    });
                    this.factorInfo.site_selected = this.checkedSites[0].id;
                    for (let i in this.checkedSites) {
                        this.checkedSitesCopy.push(this.checkedSites[i].id);
                    }
                }
                this.$refs.popoverMenu && this.$refs.popoverMenu.open()
            },
            /** 关闭右侧悬浮层 */
            hide () {
                this.$refs.popoverMenu && this.$refs.popoverMenu.hide()
                this.resetForm()
                this.$refs.userInfoForm && this.$refs.userInfoForm.clearValidate()
            },
         
            resetForm () {
                this.isShow = 0
                this.originalSites =  []
                this.checkedSites = []
                this.factorInfo = {
                    id : 0,
                    name: '',
                    contacts: '',
                    contact_number: '',
                    signDate : [],
                    sites : [],
                    status : 0,
                    remark : '',
                    site_selected : '',
                    factorInfo: []
                }
            },
            submitForm (formName) {
                this.$refs[formName].validate(async (valid) => {
                    if (valid) {
                        this.checkedSites.forEach(el => {
                            if(!el.signDate){
                                this.timeStatus = false;
                                return false;
                            }else{
                                this.timeStatus = true;
                            }
                         })

                        if(!this.timeStatus){
                              this.$message({
                                    message: '签约时间不能为空！',
                                    type: 'error',
                                    duration: 3 * 1000
                                })
                                return false;
                         }
                        let query = {
                            name:this.factorInfo.name,
                            contacts:this.factorInfo.contacts,
                            contact_number:this.factorInfo.contact_number,
                            remark:this.factorInfo.remark,
                        }
                        let status = 0;
                        await modifyFactor(this.factorInfo.id, query).then((data) => {
                            status = 1;
                            this.$message({
                                message: '修改成功',
                                type: 'success',
                                duration: 3 * 1000
                            })
                            this.$emit("reload")
                        }).catch(err => {
                            this.$message({
                                message: err.message || '修改失败',
                                type: 'error',
                                duration: 3 * 1000
                            })
                        })
                      
                      
                        let changeSite = false;
                        if(this.checkedSitesCopy.length == this.checkedSites.length){
                            for (let i in this.checkedSites) {
                                let row = this.checkedSites[i];
                                this.originalSites.filter(item => { //true 改变了 false 没有改变
                                    // 改变站点
                                    if(item.id == row.id){
                                        // 改变时间
                                        if((new Date(item.signDate[0]).getTime()/1000 != new Date(row.signDate[0]).getTime()/1000 || new Date(item.signDate[1]).getTime()/1000 != new Date(row.signDate[1]).getTime()/1000)){
                                            changeSite = true
                                        }
                                    }
                                    else{
                                        changeSite = true;
                                    }
                                });
                            }
                        }
                        if (this.checkedSites.length && (this.checkedSitesCopy.length != this.checkedSites.length || changeSite)) {
                                let sites=[];
                                this.checkedSites.forEach(el => {
                                    let site={};
                                    site.id= el.id;
                                    site.sign_start_time =new Date(el.signDate[0]).getTime()/1000;
                                    site.sign_end_time=new Date(el.signDate[1]).getTime()/1000+86400 - 1;
                                    sites.push(site)
                                });
                                let param={};
                                param.sites = sites;
                            await modifyFactorSites(this.factorInfo.id, param).then((data) => {
                                this.$message({
                                    message: '站点绑定成功',
                                    type: 'success',
                                    duration: 3 * 1000
                                })
                                if(status == 1){
                                    this.resetForm()
                                    this.hide()
                                    this.callback && this.callback();
                                }
                                this.$emit("reload")

                            }).catch(err => {
                                this.$message({
                                    message: err.message || '站点绑定签约失败',
                                    type: 'error',
                                    duration: 3 * 1000
                                })
                            })
                        }else{
                            if(status == 1){
                                this.resetForm()
                                this.hide()
                                this.callback && this.callback();
                            }
                        }
                    } else {
                        return false
                    }
                })
            },
        },
    }
</script>
<style scoped>
.bar-sub-title{
    font-size: 15px;
    background: #fafafa;
    padding: 10px 5px;
    margin: 10px 0;
}
</style>